import React from "react";
import * as S from "./index.styles";
import { CountrySelectFieldProps } from "./LocationFields.types";

const CountrySelectField: React.FC<CountrySelectFieldProps> = ({
  value, options, onChange, label, required, border
}) => (
  <S.FieldContainer>
    <S.FieldTitle>
      {label}
      {required && <S.RequiredAsterisk> *</S.RequiredAsterisk>}
    </S.FieldTitle>
    <S.StyledReactSelect
      border={border}
      options={options.map((country) => ({ value: country.name, label: country.name }))}
      value={options.find((country) => country.name === value) ? { value, label: value! } : null}
      onChange={(option: any) => onChange(option?.value ?? "")}
      placeholder={`Select ${label}`}
      isClearable
      classNamePrefix="react-select"
    />
  </S.FieldContainer>
);

export default CountrySelectField; 